'use client'

import { useEffect, useMemo, useRef, useState } from 'react'
import { trackEvent } from '@/components/@analitycs/trackEvent'
import { getDeviceInfo } from '@/utils/get-device-info'
import { sessionCookie } from '@/utils/session-cookie'
import { ProductsFilter } from './products-filter'

interface AsideProductsFilterProps {
  hasTrack: boolean
  hasPostgraduate: boolean
  workloads: string[]
}

export function AsideProductsFilter({
  hasTrack,
  hasPostgraduate,
  workloads,
}: AsideProductsFilterProps) {
  const hasTrackedRef = useRef(false)
  const [referrer, setReferrer] = useState('')
  const session = sessionCookie

  const status = session?.state.status
  const fullName = session?.state.profile.full_name
  const email = session?.state.profile.email
  const userId = session?.state.profile.reference
  const externalId = session?.state.profile.external_id
  const device = useMemo(() => getDeviceInfo(), [])

  useEffect(() => {
    setReferrer(document.referrer)
  }, [])

  useEffect(() => {
    if (hasTrackedRef.current || !referrer) return

    const eventData = {
      event: 'vitrine',
      eventName: 'page_view',
      customDataObject: {
        environment: 'Vitrine',
        item_referrer: referrer,
        item_device: device,
        ...(status === 'authenticated' && {
          user_id: userId ?? externalId,
          item_name: fullName,
          item_email: email,
        }),
      },
    }

    trackEvent(eventData)

    hasTrackedRef.current = true
  }, [status, fullName, email, device, referrer, userId, externalId])

  return (
    <aside className="mt-6 hidden w-72 shrink-0 md:block" id="filter">
      <ProductsFilter
        hasPostgraduate={hasPostgraduate}
        hasTrack={hasTrack}
        workloads={workloads}
      />
    </aside>
  )
}
